import { Injectable } from '@angular/core'
import { OssConfig } from '../config'
import { StorageBucket } from '../models'
import { environment } from '../../environments/environment'

declare var OSS: any

@Injectable() export class StorageService {

  public uploadOneFile(bucket: StorageBucket, file: File, file_name: string): Promise<any> {
    const client = this.getBucket(bucket)
    return client.multipartUpload(bucket.get_full_key(file_name), file)
  }

  public downloadOneFile(bucket: StorageBucket, objectKey: string) {
    const client = this.getBucket(bucket)
    const full_key = bucket.get_full_key(objectKey)
    return client.signatureUrl(full_key, {
      expires: 3600,
      response: {
        'content-disposition': `attachment; filename='${full_key}'`
      }
    })
  }

  public timeStampedFileName(fileName: string): string {
    return environment.upload_prefix
      + (new Date()).toISOString().replace(/:/g, '').replace(/\./g, '').replace(/-/g, '')
      + '-' + fileName
  }

  private getBucket(bucket: StorageBucket) {
    return new OSS.Wrapper({
      region: bucket.region,
      bucket: bucket.bucket,
      secure: true,
      accessKeyId: OssConfig.accessKeyId,
      accessKeySecret: OssConfig.secretAccessKey
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/services/storage.service.ts